import * as moment from 'moment';
import { MailingChannel } from '../../types/enums/mailingChannel';
import { getText } from '../text/text-service';
import { CAMPAIGN_CONFIGS } from '../../config/campaignConfigs';

export const ageResolver = (cpr: string) => {
    if (cpr.length == 12) {
        const birthPart = cpr.slice(0, 8);

        return moment().diff(moment(birthPart, 'YYYYMMDD'), 'years');
    } else {
        let wholeValue;
        const birthPart = cpr.slice(0, 6);
        if (
            birthPart.slice(0, 2) >=
            moment()
                .year()
                .toString()
                .slice(0, 2)
        ) {
            wholeValue = '19'.concat(birthPart);
        } else wholeValue = '20'.concat(birthPart);
        return moment().diff(moment(wholeValue, 'YYYYMMDD'), 'years');
    }
};

export const discountResolver = (
    percentage: number,
    price: number,
    paymentTerm: number | string
) => {
    if (paymentTerm && paymentTerm != 1) {
        switch (paymentTerm) {
            case '2':
            case 2: {
                return Math.round(
                    2 * ((price * 100) / (100 - percentage) - price)
                );
            }
            case '4':
            case 4: {
                return Math.round(
                    4 * ((price * 100) / (100 - percentage) - price)
                );
            }
            case '12':
            case 12: {
                return Math.round(
                    12 * ((price * 100) / (100 - percentage) - price)
                );
            }
            default:
                return Math.round((price * 100) / (100 - percentage)) - price;
        }
    } else return Math.round((price * 100) / (100 - percentage)) - price;
};

export const resolveDistribution = (mailingChannel: string) =>
    mailingChannel === MailingChannel.EMAIL
        ? getText('webshopsweden.common.buyingInformation.mailingChannel.email')
        : getText(
              'webshopsweden.common.buyingInformation.mailingChannel.paper'
          );

export const getPriceWithoutDiscount = (price: number, discount: number) => {
    if (price && discount) {
        return Math.round((100 * price) / (100 - discount));
    }
    return price;
};

export const getCampaignDiscountPercentage = (
    product: string,
    channel: string
) => {
    let campaignDiscountPercentage = 0;
    if (product && channel) {
        CAMPAIGN_CONFIGS.forEach(campaignInfo => {
            if (
                campaignInfo.product === product &&
                campaignInfo.channel === channel
            ) {
                campaignDiscountPercentage =
                    campaignInfo.campaignDiscountPercentage;
            }
        });
    }
    return campaignDiscountPercentage;
};
